import React, { FunctionComponent, useState, useEffect, useRef } from "react";
import InputFieldContent from "./InputFieldContent.model";
import styles from "./InputField.module.scss";
import combineClasses from "helpers/combine-classes";

const InputField: FunctionComponent<InputFieldContent> = (props) => {
    const { setFormFieldsState, formFieldsState, setRequiredFieldsEach, requiredFieldsEach, setCurrentAlerts, currentAlerts, setIsAlert, isAlert, resetFields } = props;
    const [fieldValue, setFieldValue] = useState("");
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (resetFields && ref.current) { ref.current.value = "", setFieldValue(""); }
    }, [resetFields]);

    const validateEmail = (input: string, regex: string,) => {
        const regexp = new RegExp(regex);
        if (regexp.test(input) && input.length > 0) {
            const updatedAlerts = currentAlerts;
            for (let i = 0; i < updatedAlerts.length; i++) {
                if (updatedAlerts[i] === props.invalidErrorMessage) {
                    updatedAlerts.splice(i, 1);
                    i--;
                }
            }
            setCurrentAlerts(updatedAlerts);
            setIsAlert(false);
        }
        else {
            const includesAlert = currentAlerts.length > 0 ? currentAlerts.includes(props.invalidErrorMessage) : false;
            if (!includesAlert) {
                setCurrentAlerts([...currentAlerts, props.invalidErrorMessage]);
            }
        }
    };

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        const el = e.target as HTMLInputElement;

        const includesAlias = requiredFieldsEach.length > 0 && requiredFieldsEach.includes(props.alias) ? true : false;
        if (props.mandatory && el.value.length > 0 && !includesAlias) {
            setRequiredFieldsEach([...requiredFieldsEach, props.alias]);
        }

        if (props.mandatory && el.value.length === 0 && includesAlias) {
            setRequiredFieldsEach(requiredFieldsEach.filter(e => e !== props.alias));
        }

        if (props.regex) {
            validateEmail(el.value, props.regex);
        }

        setFormFieldsState({ ...formFieldsState, [el.name]: el.value });
        if (ref.current) setFieldValue(ref.current.value);
    };

    const alertClass = fieldValue === "" && props.mandatory && isAlert ? styles.alert : undefined;
    const validateClass = currentAlerts.includes(props.invalidErrorMessage) && isAlert ? styles.validate : undefined;

    return (
        <div className={styles.input_field}>
            <label>
                <div className={styles.label_wrapper}>
                    <span className={styles.label}>{props.caption}</span> {props.mandatory ? (<span className={styles.mandatory}>*</span>) : null}
                </div>
                <input onChange={handleChange} ref={ref} type="text" className={combineClasses([styles.input, alertClass, validateClass])} name={props.alias} />
            </label>
        </div>
    );
};

export default InputField;
